import { h, defineComponent, ref, onMounted, markRaw } from 'vue'

const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'), // Your main layout
    children: [
      // Public routes
      { path: '', name: 'Home', component: () => import('pages/HomePage.vue') }, // Default page using HomePage
      { path: '/login', name: 'login', component: () => import('pages/auth/LoginPage.vue') },
      { path: '/help', name: 'help', component: () => import('pages/Help.vue') },
      {
        path: '/register',
        name: 'register',
        component: () => import('pages/auth/RegisterPage.vue')
      },

      // Game content routes - using version-specific component loader
      {
        path: '/spells',
        name: 'Spells',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('SpellsPage')
          )
      },
      {
        path: '/monsters',
        name: 'Monsters',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('MonstersPage')
          )
      },
      {
        path: '/classes',
        name: 'Classes',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('ClassesPage')
          )
      },
      {
        path: '/races',
        name: 'Races',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('RacesPage')
          )
      },
      {
        path: '/equipment',
        name: 'Equipment',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('EquipmentPage')
          )
      },
      {
        path: '/backgrounds',
        name: 'Backgrounds',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('BackgroundsPage')
          )
      },
      {
        path: '/abilities',
        name: 'Abilities',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('AbilitiesPage')
          )
      },
      {
        path: '/features',
        name: 'Features',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('FeaturesPage')
          )
      },
      {
        path: '/feats',
        name: 'Feats',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('FeatsPage')
          )
      },
      {
        path: '/skills',
        name: 'Skills',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('SkillsPage')
          )
      },
      {
        path: '/rules',
        name: 'Rules',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('RulesPage')
          )
      },
      {
        path: '/rules/:index',
        name: 'RulesDetail',
        component: () => import('pages/game/versions/base/components/RulesPage/RulesDetail.vue'),
        props: true
      },
      {
        path: '/rule-sections',
        name: 'RuleSections',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('RuleSectionsPage')
          )
      },
      {
        path: '/rule-sections/:index',
        name: 'RuleSectionsDetail',
        component: () =>
          import('pages/game/versions/base/components/RuleSectionsPage/RuleSectionsDetail.vue'),
        props: true
      },
      {
        path: '/conditions',
        name: 'Conditions',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('ConditionsPage')
          )
      },
      {
        path: '/alignments',
        name: 'Alignments',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('AlignmentsPage')
          )
      },
      {
        path: '/damage-types',
        name: 'DamageTypes',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('DamageTypesPage')
          )
      },
      {
        path: '/languages',
        name: 'Languages',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('LanguagesPage')
          )
      },
      {
        path: '/magic-schools',
        name: 'MagicSchools',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('MagicSchoolsPage')
          )
      },
      {
        path: '/weapon-properties',
        name: 'WeaponProperties',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('WeaponPropertiesPage')
          )
      },
      {
        path: '/proficiencies',
        name: 'Proficiencies',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('ProficienciesPage')
          )
      },
      {
        path: '/proficiencies/:index',
        name: 'ProficienciesDetail',
        component: () =>
          import('pages/game/versions/base/components/ProficienciesPage/ProficienciesDetail.vue'),
        props: true
      },
      {
        path: '/traits',
        name: 'Traits',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('TraitsPage')
          )
      },
      {
        path: '/weapon-properties/:index',
        name: 'WeaponPropertiesDetail',
        component: () =>
          import(
            'pages/game/versions/base/components/WeaponPropertiesPage/WeaponPropertiesDetail.vue'
          ),
        props: true
      },
      {
        path: '/subclasses',
        name: 'Subclasses',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('SubclassesPage')
          )
      },
      {
        path: '/subclasses/:index',
        name: 'SubclassesDetail',
        component: () =>
          import('pages/game/versions/base/components/SubclassesPage/SubclassesDetail.vue'),
        props: true
      },
      {
        path: '/subraces',
        name: 'Subraces',
        component: () =>
          import('../utils/versionComponentLoader').then((m) =>
            m.getVersionedComponent('SubracesPage')
          )
      },
      {
        path: '/subraces/:index',
        name: 'SubracesDetail',
        component: () =>
          import('pages/game/versions/base/components/SubracesPage/SubracesDetail.vue'),
        props: true
      },
      {
        path: '/traits/:index',
        name: 'TraitsDetail',
        component: () => import('pages/game/versions/base/components/TraitsPage/TraitsDetail.vue'),
        props: true
      },

      // Add the profile page route
      { path: 'profile', name: 'profile', component: () => import('pages/user/ProfilePage.vue') },

      // Protected routes (require authentication)
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('pages/user/DashboardPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/grants',
        name: 'grants',
        component: () => import('pages/user/GrantsPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/settings',
        name: 'settings',
        component: () => import('pages/user/SettingsPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/profile/edit',
        name: 'editProfile',
        component: () => import('pages/user/EditProfilePage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/characters',
        name: 'Characters',
        component: () => import('pages/user/CharactersPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/notes',
        name: 'Notes',
        component: () => import('../components/plugins/KnowledgeBase/pages/NotesPage.vue'),
        meta: { requiresAuth: true, hideLeftDrawer: true }
      },
      // Removed self view route; users view their own notes in the editor at /notes
      {
        path: '/u/:userId/notes/:slug',
        name: 'UserNoteView',
        component: () => import('pages/notes/NoteViewPage.vue'),
        props: true,
        meta: { hideLeftDrawer: true }
      },
      {
        path: '/u/:userId/vaults/:slug',
        name: 'UserVaultView',
        component: () => import('pages/vaults/VaultViewPage.vue'),
        props: true,
        meta: { hideLeftDrawer: true }
      },
      {
        path: '/public/characters',
        name: 'PublicCharacters',
        redirect: { name: 'discover-characters' },
        meta: { hideLeftDrawer: false }
      },
      {
        path: '/admin/vaults',
        name: 'AdminVaults',
        component: () => import('pages/admin/AdminVaultsPage.vue'),
        meta: { requiresAuth: true, hideLeftDrawer: true }
      },
      {
        path: '/characters/import',
        name: 'ImportCharacters',
        component: () => import('src/pages/user/ImportCharacterPage.vue'),
        meta: { requiresAuth: true }
      },

      // Character Sheet Routes - MOVED BEFORE CAMPAIGN ROUTES to have higher precedence
      {
        path: '/character/new',
        name: 'character-sheet-new',
        component: () => import('pages/user/CharacterSheetForm.vue'),
        props: { id: 'new' },
        meta: { requiresAuth: true }
      },
      {
        path: '/character/:id',
        name: 'character-sheet',
        component: () => import('pages/user/CharacterSheetForm.vue'),
        props: true,
        meta: { requiresAuth: true }
      },

      // Campaign routes
      {
        path: '/user/campaigns',
        name: 'campaigns',
        component: () => import('pages/user/CampaignsPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/user/campaigns/new',
        name: 'create-campaign',
        component: () => import('pages/user/CampaignFormPage.vue'),
        props: { id: 'new' },
        meta: { requiresAuth: true }
      },
      {
        path: '/user/campaigns/:id/edit',
        name: 'edit-campaign',
        component: () => import('pages/user/CampaignFormPage.vue'),
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: '/user/campaigns/:id',
        name: 'campaign-details',
        component: () => import('components/Campaign/CampaignDetailsPage.vue'),
        props: true
      },
      {
        path: '/user/campaigns/discover',
        name: 'discover-campaigns',
        component: () => import('pages/user/PublicCampaignsPage.vue')
      },
      {
        path: '/user/characters/discover',
        name: 'discover-characters',
        component: () => import('pages/user/PublicCharactersDiscoverPage.vue'),
        meta: { hideLeftDrawer: false }
      },

      // Admin routes (require authentication + admin role)
      {
        path: '/users',
        name: 'users',
        component: () => import('pages/admin/UsersPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/admin/todos',
        name: 'admin-todos',
        component: () => import('pages/admin/AdminTodosPage.vue'),
        meta: { requiresAuth: true, requiresStaff: true }
      },
      {
        path: '/admin/characters',
        name: 'admin-characters',
        component: () => import('pages/admin/CharactersPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/admin/users/:uid',
        name: 'admin-user-dashboard',
        component: () => import('pages/admin/AdminUserDashboardPage.vue'),
        props: true,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/api-tester',
        name: 'ApiTester',
        component: () => import('pages/admin/ApiTesterPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/rules-editor',
        name: 'RulesEditor',
        component: () => import('pages/admin/RulesEditorPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/ai-test',
        name: 'AiTest',
        component: () => import('pages/admin/AiTestPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/admin/ai-traces',
        name: 'AiTraceViewer',
        component: () => import('pages/admin/AiTraceViewerPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/admin/ai-evals',
        name: 'AiEvals',
        component: () => import('pages/admin/AiEvalsPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/admin/aidb',
        name: 'AidbAdmin',
        component: () => import('pages/admin/AidbAdminPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/document-parser-test',
        name: 'DocumentParserTest',
        component: () => import('pages/admin/DocumentParserTestPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/plans-admin',
        name: 'PlansAdmin',
        component: () => import('pages/admin/PlansAdminPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/admin/avatar-chat-test',
        name: 'AvatarChatTest',
        component: () => import('pages/admin/AvatarChatTestPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: '/admin/avatar-chat-sfu',
        name: 'AvatarChatSfuTest',
        component: () => import('pages/admin/AvatarChatSfuTestPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },

      // Generic detail route - MOVED AFTER specific routes
      {
        path: '/:type/:index',
        name: 'Details',
        props: true,
        component: defineComponent({
          name: 'DetailLoader',
          props: ['type', 'index'],
          setup(props) {
            const loadedComponent = ref(null)
            const loading = ref(true)
            const error = ref(null)

            // Load the component when props are available
            onMounted(async () => {
              try {
                loading.value = true
                const module = await import('../utils/versionComponentLoader')
                const component = await module.getVersionedComponent('DetailPage', {
                  type: props.type,
                  index: props.index
                })
                // Use markRaw to prevent component from being made reactive
                loadedComponent.value = markRaw(component.default || component)
              } catch (err) {
                console.error('Error loading component:', err)
                error.value = err.message
              } finally {
                loading.value = false
              }
            })

            // Return a render function that always returns a single root element
            return () => {
              // Always render a div as the root element for transition compatibility
              return h('div', { class: 'detail-page-container' }, [
                // Show loading state
                loading.value &&
                  h('div', { class: 'text-center q-pa-xl' }, [
                    h('q-spinner', { color: 'primary', size: '3em' }),
                    h('div', { class: 'text-subtitle1 q-mt-md' }, 'Loading...')
                  ]),

                // Show error state
                error.value &&
                  h('div', { class: 'text-center q-pa-xl' }, [
                    h('q-icon', { name: 'error', color: 'negative', size: '3em' }),
                    h('div', { class: 'text-subtitle1 q-mt-md' }, error.value),
                    h('q-btn', {
                      label: 'Go Back',
                      color: 'primary',
                      class: 'q-mt-md',
                      onClick: () => window.history.back()
                    })
                  ]),

                // Render the loaded component when ready
                !loading.value &&
                  !error.value &&
                  loadedComponent.value &&
                  h(loadedComponent.value, {
                    type: props.type,
                    index: props.index,
                    // Just use a single consistent prop naming
                    onBack: () => window.history.back() // Add the onBack prop with a function to go back
                  })
              ])
            }
          }
        })
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
